import PageTabs from '@/components/page/PageTabs';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import OutputViewerSection from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/OutputViewerSection';

const labels = {
  data: 'Sent Payload',
  originalData: 'Original Payload',
  args: 'Original Body'
};

const PayloadSection = ({ request }) => {
  const { arguments: args, data, originalData } = request;
  const method = request?.method;
  const url = request?.url;

  const tabData = [
    { key: 'data', value: data },
    { key: 'originalData', value: originalData },
    { key: 'args', value: args?.body }
  ].filter((n) => !!n.value);

  const tabKey = 'payloadSectionLogTab';
  const defaultTab = tabData[0]?.key || 'data';
  const activeTab = useArgSelector(query, tabKey) || defaultTab;

  const childrenMap = {};
  const items = [];

  tabData.forEach((n) => {
    childrenMap[n.key] = <OutputViewerSection.CodeBlock code={n.value} />;
    items.push({ value: n.key, label: labels[n.key] });
  });

  if (!data && !originalData && !args) {
    return (
      <OutputViewerSection className={'py-2'}>
        <OutputViewerSection.CodeBlock code={request} />
      </OutputViewerSection>
    );
  }

  return (
    <OutputViewerSection className={'logs py-2'}>
      {method && url && (
        <div className={'signature'}>
          <div className={`method ${method?.toLowerCase()}`}>{method}</div>
          <div className={'url'}>{url}</div>
        </div>
      )}
      <PageTabs items={items} tabKey={tabKey} defaultTab={defaultTab} />
      <div className="content">{activeTab !== undefined && childrenMap[activeTab]}</div>
    </OutputViewerSection>
  );
};

export default PayloadSection;
